const ZOOM_FACTORS = [1.5, 2, 3, 4, 6, 8, 16];

export type ZoomAppearanceOption = { label: string; value: number | ''; };

export function zoomOffsetFromFactor(factor: number): number {
	return Math.log2(factor);
}

export function zoomFactorFromOffset(offset: number): number {
	return Math.round(2 ** offset * 10) / 10;
}

export function zoomFactorLabel(offset: number): string {
	return `×${String(zoomFactorFromOffset(offset)).replace('.', ',')}`;
}

export function zoomAppearanceOptions(current?: number): ZoomAppearanceOption[] {
	const offsets = ZOOM_FACTORS.map(zoomOffsetFromFactor);

	if (current && current > 0 && !offsets.includes(current)) {
		offsets.push(current);
		offsets.sort((a, b) => a - b);
	}

	return [
		{ label: 'Toujours visible', value: '' },
		...offsets.map(offset => ({ label: `À partir du zoom ${zoomFactorLabel(offset)}`, value: offset })),
	];
}
